// Components==============
import ArrowButton from 'components/UI/ArrowButton';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './SideButtons.module.scss';
// =========================

export default function SideButtons() {
    const { pathname } = useLocation();
    const routeSlug = pathname.split('/')[1];

    const page = useSelector((state) => {
        const pages = state.page.entities.allIds.map(
            (pageId) => state.page.entities.byId[pageId]
        );
        return pages.find((p) => p.slug === routeSlug);
    });

    const buttons = page?.buttons?.map((b) => b.attributes);

    return (
        <>
            {buttons?.length ? (
                <div styleName="buttons-wrapper">
                    <div styleName="buttons">
                        {buttons?.map((e) => (
                            <ArrowButton
                                // popup={e?.popup}
                                // popupAccent={e?.popup_accent}
                                key={e?.text}
                                text={e?.text}
                                subtitle={e?.subtitle}
                                to={e?.link}
                                type={e?.type}
                                file={e?.file}
                            />
                        ))}
                    </div>
                </div>
            ) : null}
        </>
    );
}
